import axios from 'axios';
import axiosConfig from '../../../config/axios.config';


export default addedPIs => {
  // console.log(addedPIs, "PIs")
  let result = [];
  let pis = addedPIs.slice();
  return new Promise((resolve, reject) => {
    const fetch = () => {
      const pi = pis.pop();
      let stagingID = pi && pi._id ? pi._id : pi ? pi.image._id : null;
      let total = pis.length;
      axios.get(axiosConfig.localUrl + '/backend/unstage_media/' + stagingID)
      .then(res => {
        if (res && !res.error && res.data && !res.data.error) {

          result.push({
            ...pi,
            image: res.data.media_file._id,
          })
          if (total) fetch()
          else {
            return resolve(result);
          }
        }
      })
      .catch(err => reject(err));
    }
    if (pis.length > 0) {
      fetch();
    } else {
      resolve(addedPIs);
    }
  });
}
